/* eslint-disable*/
import React, { useEffect } from 'react';

import { Card, Dropdown, Col, Row } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import { useSelector, useDispatch } from 'react-redux';
import CsLineIcons from 'cs-line-icons/CsLineIcons';

import { aggiornaFatturatiPerCliente } from 'features/dashboard/dashboardSlice';
import { aggiornaCurrentCliente, aggiornaClienti } from 'features/global/globalSlice';
import { groupByClienti, filtraDatiClienti } from './funzioni';

const GraficoPerCliente = ({ hideData }) => {
  const { fatturatiRaw, fatturatiPerCliente, raggruppamento, anno, valuta } = useSelector((state) => state.dashboard);
  const { currentCliente, clienti } = useSelector((state) => state.global);
  const { themeValues } = useSelector((state) => state.settings);

  const dispatch = useDispatch();

  useEffect(() => {
    if (fatturatiRaw || anno) {
      const fattGroup = groupByClienti(fatturatiRaw);
      const clienti = _.groupBy(fatturatiRaw[anno], (o) => o?.Customer?.trim());

      dispatch(aggiornaClienti(Object.keys(clienti).sort()));
      dispatch(aggiornaFatturatiPerCliente(fattGroup));
      if (!currentCliente) dispatch(aggiornaCurrentCliente(Object.keys(clienti).sort()[0]));
    }
  }, [fatturatiRaw, anno, currentCliente]);

  const GraficoTotale = () => (
    <Bar
      data={{
        labels: filtraDatiClienti(fatturatiPerCliente, raggruppamento, anno, currentCliente).map((f) => f.etichetta),
        datasets: [
          {
            label: 'Totale',
            data: filtraDatiClienti(fatturatiPerCliente, raggruppamento, anno, currentCliente).map((f) => f.valoreTotale),
            backgroundColor: themeValues.primary,
            pointBackgroundColor: themeValues.primary,
            pointBorderColor: themeValues.primary,
            pointHoverBackgroundColor: themeValues.primary,
            pointHoverBorderColor: themeValues.primary,
            pointRadius: 3,
            pointBorderWidth: 3,
            borderRadius: themeValues.borderRadiusMd.replace('px', ''),
          },
        ],
      }}
    />
  );

  const GraficoVolumi = () => (
    <Bar
      data={{
        labels: filtraDatiClienti(fatturatiPerCliente, raggruppamento, anno, currentCliente).map((f) => f.etichetta),
        datasets: [
          {
            label: 'Volums',
            data: filtraDatiClienti(fatturatiPerCliente, raggruppamento, anno, currentCliente).map((f) => f.valoreVolumi),
            backgroundColor: themeValues.primary,
            pointBackgroundColor: themeValues.primary,
            pointBorderColor: themeValues.primary,
            pointHoverBackgroundColor: themeValues.primary,
            pointHoverBorderColor: themeValues.primary,
            pointRadius: 3,
            pointBorderWidth: 3,
            borderRadius: themeValues.borderRadiusMd.replace('px', ''),
          },
        ],
      }}
    />
  );

  return (
    <>
      <section className="scroll-section mt-5">
        <Card>
          <Card.Header className="d-flex flex-row align-items-center">
            <Card.Title>Statistics by customer</Card.Title>

            <select
              className="ms-2"
              onChange={(e) => {
                dispatch(aggiornaCurrentCliente(e.target.value));
              }}
            >
              {fatturatiPerCliente &&
                fatturatiPerCliente[anno] &&
                Object.keys(fatturatiPerCliente[anno])
                  .sort()
                  .map((c, i) => {
                    return (
                      <option key={i} value={c} selected={c === currentCliente}>
                        {c}
                      </option>
                    );
                  })}
            </select>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col sm={12} md={12} lg={6} className="mb-md-4">
                <Card border>
                  <Card.Body>
                    <Card.Title>Statistics by volume (kg)</Card.Title>
                    <GraficoVolumi />
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={12} md={12} lg={6}>
                <Card border>
                  <Card.Body>
                    <Card.Title>Statistics by value (€)</Card.Title>
                    <GraficoTotale />
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <table className="table table-striped ">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">Volume (kg) {anno}</th>
                    <th scope="col">
                      Value ({valuta}) {anno}
                    </th>
                    <th scope="col">Volume (kg) {anno - 1} </th>
                    <th scope="col">
                      Value ({valuta}) {anno - 1}
                    </th>
                    <th>Comparison</th>
                  </tr>
                </thead>
                <tbody>
                  {filtraDatiClienti(fatturatiPerCliente, raggruppamento, anno, currentCliente).map((e) => {
                    return (
                      <tr key={JSON.stringify(e)}>
                        <th scope="row">{e.etichetta}</th>
                        <td>
                          kg{' '}
                          {parseFloat(e.valoreVolumi, 10)
                            .toFixed(3)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </td>

                        {hideData ? (
                          <td>*Redacted*</td>
                        ) : (
                          <td>
                            {valuta}{' '}
                            {parseFloat(e.valoreTotale, 10)
                              .toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          </td>
                        )}
                        <td>
                          kg.
                          {parseFloat(e.volumiAnnoPrima, 10)
                            .toFixed(2)
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </td>

                        {hideData ? (
                          <td>*Redacted*</td>
                        ) : (
                          <td>
                            {valuta}{' '}
                            {parseFloat(e.totaleAnnoPrima, 10)
                              .toFixed(2)
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          </td>
                        )}
                        <td>
                          {parseFloat(e.volumiAnnoPrima, 10) > parseFloat(e.valoreVolumi, 10) ? (
                            <CsLineIcons icon="trend-down" size="20" className="text-danger" />
                          ) : (
                            <CsLineIcons icon="trend-up" size="20" className="text-success" />
                          )}

                          <span className="ms-2">{(((e.valoreVolumi - e.volumiAnnoPrima) / e.volumiAnnoPrima) * 100).toFixed(2)}%</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Row>
          </Card.Body>
        </Card>
      </section>
    </>
  );
};

export default GraficoPerCliente;
